module.exports = __webpack_public_path__ + "static/3-3c7baeaf3d8a61ba9bc3393379273b43.jpg";